import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import DocumentItem from '@/entity/components/content/components/document-item';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import Subsection from '../../../subsection';
type ContentProps = {
  entity: Entity;
  documents: TransformedDocument[];
  seqno?: number;
};
const Content = t0 => {
  const $ = _c(9);
  const {
    entity,
    documents,
    seqno
  } = t0;
  let t1;
  if ($[0] !== documents || $[1] !== entity || $[2] !== seqno) {
    let t2;
    if ($[4] !== entity || $[5] !== seqno) {
      t2 = document => <DocumentItem key={`onboarding-document-${document.startedAt}`} document={document} entity={entity} value={`${document.kind}-${document.completedVersion}`} showOnboardingLink={false} readOnly={true} seqno={seqno} />;
      $[4] = entity;
      $[5] = seqno;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = documents.map(t2);
    $[0] = documents;
    $[1] = entity;
    $[2] = seqno;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <Subsection>{t1}</Subsection>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default Content;